var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0648 14.5989H15.8332V30H22.0648V14.5989Z",
    fill: "#922731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1668 14.5989H8.93517V30H15.1668V14.5989Z",
    fill: "#922731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0L5.29774 9.89305H25.7023L15.5 0Z",
    fill: "#922731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27432 14.5989H3.41896V30H8.27432V14.5989Z",
    fill: "#922731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.581 14.5989H22.7257V30H27.581V14.5989Z",
    fill: "#922731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5882V13.9038H3.09126H8.60747H15.5H22.3925H27.9087H31V10.5882H0Z",
    fill: "#922731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilities);
export default __webpack_public_path__ + "static/media/Facilities.cf2b9dba5ed05ccfdea990b967400a62.svg";
export { ForwardRef as ReactComponent };